import React from 'react';

export const MoreRepliesIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="8"
            fill="none"
            viewBox="0 0 10 8"
        >
            <path
                fill="#000"
                d="M3.363 4.701h3.07L4.296 6.793l1.031 1.078 3.85-3.89L5.326.09 4.295 1.168l2.139 2.098H3.51c-1.489 0-2.08-.71-2.08-2.168V.793H0v.469c0 2.32 1.06 3.44 3.363 3.44z"
            ></path>
        </svg>
    );
};
